import React from "react";

export default function RightArrowButton(){
    return (
        <i className={'td-icon icon-small td-icon-arrowRight'} style={{float:'right', fontSize:'1.9em'}}/>
    )
}
